export default __webpack_public_path__ + "static/media/Event@32.91eaa250.svg";